import { SectionTitle } from "@packages/core-client/components/SectionTitle.tsx";

export function ComingSoonPage() {
    return (
        <div className="mt-8">
            <SectionTitle>Coming soon</SectionTitle>
            <p className="text-muted-fg mt-2 text-sm">This page hasn't been built yet.</p>
        </div>
    );
}
